import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    '& .MuiInputLabel-root': {
      whiteSpace: 'nowrap',
    },
  },
  damageFields: {
    width: '100%',
  },
});

export { useStyles };
